module.exports = __webpack_public_path__ + "assets/free-901a4ede2edbc983a8d712663977ce61.svg";